module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Viddora.972b571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Viddora.jpg
// module id = 1Wo/
// module chunks = 0